export const INIT_LOCAL_STORE = "INIT_LOCAL_STORE";
export const SET_STORAGE_ITEM = "SET_STORAGE_ITEM";
export const REMOVE_STORAGE_ITEM = "REMOVE_STORAGE_ITEM";
export const RESET_LOCAL_STORAGE = "RESET_LOCAL_STORAGE";
